export const fallbackLng = 'en';
export const languages = ['en', 'sv'];
export const defaultNS = 'common';

export type LanguageValue = (typeof languages)[number];

/**
 * Generates configuration options for i18n initialization.
 *
 * @param lng - The language to use. Defaults to the fallback language.
 * @param ns - The namespace to use. Defaults to the default namespace.
 * @returns An object containing i18n configuration options including:
 *   - lng: The language to use
 *   - fallbackLng: The fallback language
 *   - ns: The namespace(s) to use
 *   - defaultNS: The default namespace
 *   - fallbackNS: The fallback namespace (set to defaultNS)
 *   - supportedLngs: Array of supported languages
 */
export function i18nOptions(lng = fallbackLng, ns = defaultNS) {
    return {
        // debug: true,
        lng,
        fallbackLng,
        ns,
        defaultNS,
        fallbackNS: defaultNS,
        supportedLngs: languages,
    };
}

export const changeLangMessages: Record<
    LanguageValue,
    { success: string; error: string; loading: string }
> = {
    en: {
        success: 'Language has been changed!',
        error: 'Error changing language!',
        loading: 'Loading...',
    },
    sv: {
        success: 'Språket har ändrats!',
        error: 'Fel vid ändring av språk!',
        loading: 'Laddar...',
    },
};
